import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["classroomFilter", "courseContainer", "courseSelect"]

  filterCourses(event) {
    const classroomId = event.target.value
    
    if (!classroomId) {
      this.courseContainerTarget.style.display = "none"
      return
    }

    fetch(`/schools/pedagogical_projects/filter_courses?classroom_id=${classroomId}`, {
      headers: {
        "Accept": "application/json"
      }
    })
    .then(response => response.json())
    .then(courses => {
      const defaultOption = this.courseSelectTarget.options[0].text
      this.courseSelectTarget.innerHTML = `
        <option value="">${defaultOption}</option>
        ${courses.map(course => `<option value="${course.id}">${course.name}</option>`).join('')}
      `
      this.courseContainerTarget.style.display = "block"
    })
  }
}